<div id="root">
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeForm()"></button>
  <div class="App-Container is-darkBackground App-Container--noAnimation flex-container justify-content-center" data-testid="checkout-container">
    <div class="App App--multiItem">
      <div class="App-Overview is-darkBackground" style="background-color: #F8F8F8;">
        <header class="Header is-darkBackground" style="background-color: #F8F8F8;">
          <div class="Header-content flex-container justify-content-space-between align-items-stretch">
            <div class="Header-business flex-item width-grow flex-container align-items-center">
              <div class="Header-merchantLogoWithLabel">
                <div class="HeaderImage HeaderImage--logo flex-item width-fixed flex-container justify-content-center align-items-center width-fixed">
                  <img alt="{{locationV2.description}}. logo" [src]="siteMeta.lightBigLogoUrl" class="HeaderImage-img" loading="lazy"></div>
                <span class="Header-businessLink-label Text Text-color--gray800 Text-fontSize--14 Text-fontWeight--500">Back</span>
              </div>
            </div>
          </div>
        </header>
        <div class="OrderSummaryColumn" data-testid="order-summary-column">
          <div data-testid="product-summary" class="ProductSummary is-clickable">
            <div class="ProductSummary-productImageContainer is-clickable" data-testid="product-summary-product-image">
              <div class="pack-details-container">
                <ng-container *ngIf="menuPack.IsSubscription">
                  <div class="pack-details subscription" [style.background-image]="'url(' + getPackImage() + ')'">
                    <div *ngIf="menuPack.DecoyPrice > 0 && menuPack.DecoyPrice != menuPack.Price" class="ribbon">Save  ${{(menuPack.DecoyPrice - menuPack.Price)/100}}</div>
                    <h4 class="pack-name" [innerHTML]="getMenuPackNameById()"></h4>
                    <p class="price">
                      <span class="decoy-price" *ngIf="menuPack.DecoyPrice > 0 && menuPack.DecoyPrice != menuPack.Price">${{menuPack.DecoyPrice/100}}</span>
                    </p>
                    <p class="price">
                      <span class="actual-price">${{menuPack.Price/100}}</span><span class="unit">{{getTermDuration()}}</span>
                    </p>
                    <p class="description" [innerHTML]="getPackDescriptionById()"></p>
                  </div>
                </ng-container>
                <ng-container *ngIf="!menuPack.IsSubscription">
                  <div class="pack-details pack">
                    <h4 class="pack-name" [innerHTML]="getMenuPackNameById()"></h4>
                    <p class="price">
                      <span class="decoy-price" *ngIf="menuPack.DecoyPrice > 0 && menuPack.DecoyPrice != menuPack.Price">${{menuPack.DecoyPrice/100}}</span>
                    </p>
                    <p class="price">
                      <span class="actual-price">${{menuPack.Price/100}}</span><span class="unit">{{getTermDuration()}}</span>
                    </p>
                    <p class="expiry-label">{{getPackExpiryLabel()}}</p>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="ProductSummary-info is-clickable is-darkBackground">
              <span class="ProductSummary-name Text Text-color--gray500 Text-fontSize--16 Text-fontWeight--500" data-testid="product-summary-name">Pay {{locationV2.description}}.</span>
              <div class="ProductSummary-amountsContainer false">
                <div class="ProductSummary-totalsRead" style="opacity: 1;">
                  <div class="ProductSummary-totalAmountContainer is-clickable" style="opacity: 1;">
                    <span class="ProductSummary-totalAmount Text Text-color--default Text-fontWeight--600 Text--tabularNumbers" id="ProductSummary-totalAmount" data-testid="product-summary-total-amount">
                      <span class="CurrencyAmount">US{{formatCurrency(((rateLockFees / 100) + (processingFees / 100)))}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            data-testid="order-details"
            class="OrderDetails App-Overview-OrderDetails"
            [ngClass]="{ 'Active': isOrderDetailsVisible }"
          >
            <ul class="OrderDetails-items">
              <li class="OrderDetails-item" style="opacity: 1; transform: scale(1); height: auto; margin-bottom: 16px;">
                <div class="LineItem flex-container align-items-flex-start">
                  <div class="flex-container justify-content-space-between align-items-baseline wrap-wrap width-grow">
                    <div class="flex-column-break" style="order: 2;"></div>
                    <div class="flex-column-break" style="order: 5;"></div>
                    <div class="LineItem-productName flex-item width-auto" data-testid="line-item-product-name" style="order: 0;">
                      <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                        <div class="ExpandableText false">
                          <div data-testid="" class="ExpandableText--truncated" style="-webkit-line-clamp: 2;">Rate Lock Fee (non-refundable)</div>
                        </div>
                      </span>
                    </div>
                    <div class="LineItem-tierBreakdown flex-item width-auto flex-item-align-left" style="order: 6;">
                      <div class="flex-container" data-testid="line-item-tiers"></div>
                    </div>
                    <div class="flex-container Placeholder" style="opacity: 1;">
                      <div class="ml2 flex-item width-fixed" data-testid="line-item-total-amount" style="order: 1;">
                        <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                          <span class="CurrencyAmount">US{{formatCurrency((rateLockFees / 100))}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="OrderDetails-footer">
              <div class="is-indented">
                <div class="OrderDetailsFooter-subtotal flex-container justify-content-space-between">
                  <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">Subtotal</span>
                  <div class="flex-container Placeholder" style="opacity: 1;"><span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--600 Text--tabularNumbers" id="OrderDetailsFooter-SubtotalAmount">
                    <span class="CurrencyAmount">US{{formatCurrency((rateLockFees / 100))}}</span></span></div>
                </div>
                <!-- <div class="OrderDetailsFooter-subtotalItems flex-container direction-column" *ngIf="taxAmount > 0">
                  <div class="FadeWrapper"></div>
                  <div>
                    <div class="OrderDetailsSubtotalItem flex-container justify-content-space-between">
                      <div>
                        <div class="flex-container">
                          <span class="OrderDetails-subtotalItemLabel-Text Text Text-color--gray900 Text-fontSize--14">
                            Tax
                          </span>
                        </div>
                      </div>
                      <div class="flex-container Placeholder" style="opacity: 1;"><span class="Text Text-color--gray400 Text-fontSize--14 Text--tabularNumbers">
                        <span class="CurrencyAmount">US{{formatCurrency((taxAmount / 100))}}</span></span></div>
                    </div>
                  </div>
                </div> -->
                <div class="OrderDetailsFooter-subtotalItems flex-container direction-column" *ngIf="processingFees > 0">
                  <div class="FadeWrapper"></div>
                  <div>
                    <div class="OrderDetailsSubtotalItem flex-container justify-content-space-between">
                      <div>
                        <div class="flex-container">
                          <span class="OrderDetails-subtotalItemLabel-Text Text Text-color--gray900 Text-fontSize--14">
                            Processing Fees ({{processingFeesPercentage}}%)
                          </span>
                        </div>
                      </div>
                      <div class="flex-container Placeholder" style="opacity: 1;"><span class="Text Text-color--gray400 Text-fontSize--14 Text--tabularNumbers">
                        <span class="CurrencyAmount">US{{formatCurrency((processingFees / 100))}}</span></span></div>
                    </div>
                  </div>
                </div>
                <div class="OrderDetails-total flex-container justify-content-space-between">
                  <span><span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">Total due today</span></span>
                  <div class="flex-container Placeholder" style="opacity: 1;">
                    <span class="Text Text-color--default Text-fontSize--16 Text-fontWeight--600 Text--tabularNumbers" id="OrderDetails-TotalAmount">
                      <span class="CurrencyAmount">US{{formatCurrency(((rateLockFees / 100) + (processingFees / 100)))}}</span>
                    </span>
                  </div>
                </div>
                <div class="OrderDetails-upcomingPayment flex-container justify-content-space-between">
                  <div class="LineItem-productDescription flex-item width-12" style="order: -1;">
                    <div class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                      <div class="ExpandableText false">
                        <div data-testid="line-item-product-description" class="ExpandableText--truncated" style="-webkit-line-clamp: 2;">
                          Upcoming payments
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="OrderDetails-items">
                  <li class="OrderDetails-item" style="opacity: 1; transform: scale(1); height: auto; margin-bottom: 16px;">
                    <div class="LineItem flex-container align-items-flex-start">
                      <!-- <div class="LineItem-imageContainer mr4 flex-item width-fixed" data-testid="line-item-image" *ngIf="pack.Image">
                        <img [src]="pack.Image" [alt]="menuPack.Name" class="LineItem-image">
                      </div> -->
                      <div class="flex-container justify-content-space-between align-items-baseline wrap-wrap width-grow">
                        <div class="flex-column-break" style="order: 2;"></div>
                        <div class="flex-column-break" style="order: 5;"></div>
                        <div class="LineItem-productName flex-item width-auto" data-testid="line-item-product-name" style="order: 0;">
                          <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">
                            <div class="ExpandableText false">
                              <div data-testid="" class="ExpandableText--truncated" style="-webkit-line-clamp: 2;">{{menuPack.Name}}</div>
                            </div>
                          </span>
                        </div>
                        <div class="flex-container direction-column wrap-wrap" style="width: 100%; order: 3;">
                          <div class="LineItem-productDescription flex-item width-12" style="order: -1;">
                            <div class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                              <div class="ExpandableText false">
                                <div data-testid="line-item-product-description" class="ExpandableText--truncated" style="-webkit-line-clamp: 2;">
                                  {{pack.Description}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-container direction-row wrap-wrap">
                            <div class="LineItem-description flex-item width-grow" style="order: 3;"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Due on opening</span></div>
                            <div class="LineItem-amountDetail flex-item width-auto flex-container align-items-flex-end width-auto" data-testid="line-item-amount-detail" style="order: 4;">
                              <div class="flex-item width-auto flex-item-align-right">
                                <div class="flex-container Placeholder" style="opacity: 1;"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                                  <span class="CurrencyAmount">US{{formatCurrency((menuPack.Price / 100))}}</span> {{getTermDuration()}}</span></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="LineItem-tierBreakdown flex-item width-auto flex-item-align-left" style="order: 6;">
                          <div class="flex-container" data-testid="line-item-tiers"></div>
                        </div>
                        <div class="flex-container Placeholder" style="opacity: 1;">
                          <div class="ml2 flex-item width-fixed" data-testid="line-item-total-amount" style="order: 1;">
                            <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500 Text--tabularNumbers">
                              <span class="CurrencyAmount">US{{formatCurrency((menuPack.Price / 100))}}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="OrderDetailsFooter-otherFee flex-container justify-content-space-between">
                  <span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--500">Annual Maintenance Fee</span>
                  <div class="flex-container Placeholder" style="opacity: 1;"><span class="Text Text-color--default Text-fontSize--14 Text-fontWeight--600 Text--tabularNumbers" id="OrderDetailsFooter-SubtotalAmount">
                    <span class="CurrencyAmount">US{{formatCurrency((49.99))}}</span></span></div>
                </div>
                <div class="LineItem-productDescription flex-item width-12" style="order: -1;">
                  <div class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                    <div class="ExpandableText false">
                      <div data-testid="line-item-product-description" class="ExpandableText--truncated" style="-webkit-line-clamp: 2;">
                        Due second month of opening
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="App-Payment">
        <main>
          <div class="CheckoutPaymentForm">
            <div style="height: 36.7969px;">
              <div>
                <div class="PaymentRequestOrHeader" style="display: inherit; height: auto;">
                  <div class="AnimateSinglePresence">
                    <div class="AnimateSinglePresenceItem">
                      <div>
                        <div class="PaymentHeaderContainer" style="display: block; opacity: 1;">
                          
                        </div>
                        <div class="ButtonAndDividerContainer" style="display: none; opacity: 0; height: 0px;">
                          <div class="ButtonContainer">
                            <div class="ButtonWrapper">
                              <div class="ButtonWrapper"></div>
                            </div>
                          </div>
                          <div></div>
                          <div class="Divider">
                            <hr>
                            <p class="Divider-Text Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400"><span class="DividerText">Or pay another way</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form class="PaymentForm-form" novalidate="" *ngIf="paymentForm" [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
              <input type="hidden" formControlName="MenuPackId" />
              <input type="hidden" formControlName="Amount" />
              <input type="hidden" formControlName="Currency" />
              <input type="hidden" formControlName="PaymentMethod" />
              <div class="" style="position: relative;">
                <div class="flex-container spacing-16 direction-column wrap-wrap">
                  <div class="flex-item width-12">
                    <div class="FormFieldGroup" data-qa="FormFieldGroup-email">
                      <div class="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                        <label for="email-fieldset">
                          <span class="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">Contact information</span></label>
                        <div style="opacity: 1; transform: none;"></div>
                      </div>
                      <fieldset class="FormFieldGroup-Fieldset" id="firstName-fieldset">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="FormFieldGroup-container">
                              <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                                <div class="form-floating">
                                  <input #email type="text" name="FirstName" formControlName="FirstName" class="form-control" id="FirstName" placeholder="FirstName" required autofocus (focusout)="validateField('FirstName')" />
                                  <label for="FirstName">First Name</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="FormFieldGroup-container LastNameField">
                              <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                                <div class="form-floating">
                                  <input #email type="text" name="LastName" formControlName="LastName" class="form-control" id="LastName" placeholder="LastName" required autofocus (focusout)="validateField('LastName')" />
                                  <label for="LastName">Last Name</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="email-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <input #email type="email" name="email" formControlName="Email" class="form-control" id="email" placeholder="Email" required autofocus (focusout)="validateField('Email')" />
                              <label for="email">Email</label>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="phoneNumber-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childBottom">
                            <div class="FormFieldInput">
                              <div class="PhoneNumberInput">
                                <div class="input-group has-validation">
                                  <span class="input-group-text" (click)="country.open(countryCode, phone)">
                                    <img [src]="flagUrl" class="flag">
                                    <span class="px-1">{{dialCode}}</span>
                                  </span>
                                  <div class="form-floating">
                                    <input #phone type="tel" name="phone" formControlName="PhoneNumber" class="form-control" id="phone" placeholder="Mobile Number" required autofocus (focusout)="validateField('PhoneNumber')" />
                                    <label for="phone">Phone Number</label>
                                  </div>
                                  <div class="invalid-feedback">
                                    Please enter a phone number.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="email-notification-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <div class="CheckboxField">
                                <div class="Checkbox">
                                  <div class="Checkbox-InputContainer">
                                    <input #emailNotification type="checkbox" name="emailNotification" formControlName="EmailNotification" id="emailNotification" placeholder="Email Notification" autofocus class="Checkbox-Input" (change)="onTermsOfServiceChange($event)" />
                                  </div>
                                  <div><label for="emailNotification"><span class="Checkbox-Label Text Text-color--gray900 Text-fontSize--13 Text-fontWeight--500">Email me with news and updates</span></label></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset class="FormFieldGroup-Fieldset" id="sms-notification-fieldset">
                        <div class="FormFieldGroup-container">
                          <div class="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                            <div class="form-floating">
                              <div class="CheckboxField">
                                <div class="Checkbox">
                                  <div class="Checkbox-InputContainer">
                                    <input #smsNotification type="checkbox" name="smsNotification" formControlName="SmsNotification" id="smsNotification" placeholder="Sms Notification" autofocus class="Checkbox-Input" (change)="onSmsNotificationChange($event)" />
                                  </div>
                                  <div><label for="smsNotification"><span class="Checkbox-Label Text Text-color--gray900 Text-fontSize--13 Text-fontWeight--500">Text me with news and updates</span></label></div>
                                </div>
                              </div>
                              <div id="smsNotificationInfo" *ngIf="isSmsNotificationVisible">
                                <label for="smsNotification" class="smsNotifText">
                                  <span class="Checkbox-Label Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">I agree to receive text messages from {{siteMeta?.name}} about my membership, bookings and offers.
                                    Message frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
                                    See our <a class="smsConsentLink" [href]="siteMeta?.privacyPolicyUrl" target="_blank" rel="noopener">Privacy Policy</a>
                                    and <a class="smsConsentLink" [href]="siteMeta?.termsUrl" target="_blank" rel="noopener">Terms</a>.
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <!-- <div class="loading-bg justify-content-center" *ngIf="!isLoading"></div>
                <div class="loading justify-content-center" *ngIf="!isLoading"><img src="assets/images/loading.gif" /></div> -->
                <div class="flex-item width-12">
                  
                </div>
                <div class="PaymentMethodForm" style="opacity: 1; height: auto; margin-top: 10px;">
                  <div id="payment-element"></div>
                </div>
                <div class="PaymentForm-confirmPaymentContainer mt2 flex-item width-grow">
                  <div class="ConfirmPayment">
                    <div class="FormFieldCheckbox TermsOfServiceConsentCheckbox">
                      <div class="CheckboxField">
                        <div class="Checkbox">
                          <div class="Checkbox-InputContainer">
                            <input id="termsOfServiceConsentCheckbox" name="termsOfServiceConsentCheckbox" type="checkbox" class="Checkbox-Input" required (change)="onTermsOfServiceChange($event)" />
                          </div>
                          <div><label for="termsOfServiceConsentCheckbox"><span class="Checkbox-Label Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">I agree to {{locationV2.description}}.'s <a class="Link TermsOfServiceConsentCheckbox-customMessageLink Link--checkout--secondary" href="/assets/pdf/FitnessFactoryHarlem_TermsAndConditions.pdf" target="_blank" rel="noopener">Terms of Service</a> and <a class="Link TermsOfServiceConsentCheckbox-customMessageLink Link--checkout--secondary" href="/assets/pdf/DropFitness_PrivacyPolicy.pdf" target="_blank" rel="noopener">Privacy Policy</a></span></label></div>
                        </div>
                      </div>
                    </div>
                    <div class="AnimateSinglePresence"></div>
                    <div class="flex-item width-12"></div>
                    <div class="row">
                      <div class="col-sm-6">
                        <button class="SubmitButton" type="submit" [disabled]="isButtonDisabled" data-testid="hosted-payment-submit-button" style="background-color: rgb(0, 116, 212); color: rgb(255, 255, 255);">
                          Pay
                        </button>
                      </div>
                      <div class="col-sm-6">
                        <button class="SubmitButton" type="button" aria-label="Cancel" data-testid="hosted-payment-submit-button" style="background-color: #dfdfdf; color: #000000;" (click)="closeForm()">
                          Cancel
                        </button>
                      </div>
                    </div>
                    <div class="flex-item width-12">
                      <div class="ConfirmPayment-PostSubmit">
                        <div class="ConfirmTerms">
                          <div class="AnimateSinglePresence"></div>
                          <div class="AnimateSinglePresence">
                            <div class="AnimateSinglePresenceItem ConfirmPaymentTerms">
                              <div>
                                <div class="ConfirmTerms Text Text-color--gray600 Text-fontSize--13" data-testid="ConfirmPaymentTermsText">
                                  <div class="AnimateSinglePresence"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="AnimateSinglePresence"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </main>
        <footer class="App-Footer Footer">
          <div class="Footer-PoweredBy">
            <a class="Link Link--primary" href="https://tech.dropfitness.com" target="_blank" rel="noopener">
              <div class="Footer-PoweredBy-Text Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                Powered by 
                <span>
                  <img class="logo-img" [src]="logo" width="15" />
                </span>
              </div>
            </a>
          </div>
          <div class="CheckoutFooter-links flex-container direction-row">
            <a class="Link CheckoutFooter-link Link--checkout--secondary" [href]="siteMeta.termsUrl" target="_blank" rel="noopener"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Terms</span></a>
            <a class="Link CheckoutFooter-link Link--checkout--secondary" [href]="siteMeta.privacyPolicyUrl" target="_blank" rel="noopener"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Privacy</span></a></div>
        </footer>
      </div>
    </div>
  </div>
  <df-country-select #country (select)="changeCountry($event)"></df-country-select>
</div>